import React from "react";
import { useTicketingContext } from "../../store";
import { getDefaultPath, pathRegex } from "../../api/api";

const UserAvatar = ({ className = "" }) => {
  const { state } = useTicketingContext();
  const loggedIn = state.loginSessionData?.loggedIn;
  const match = window.location.pathname.match(pathRegex) || [];
  const local = match[1] || "english";
  const path = (match[2] || "").replace(/\/$/, "") || getDefaultPath(local);

  const loginUrl = new URL(`${window.LOGIN_WORKER_URL}auth/start`);

  loginUrl.searchParams.set("return_to", `${local}/${path}`);

  const accountProfileUrl = `https://shopify.com/${window.SHOPIFY_SHOP_ID}/account/profile`;

  const redirectUser = async () => {
    if (loggedIn) {
      await fetch(`${window.LOGIN_WORKER_URL}auth/cache-clear`, {
        method: "POST",
        credentials: "include",
      });
      const profileUrl = new URL(accountProfileUrl);
      if (profileUrl.protocol === "https:") {
        window.location.href = profileUrl.toString();
      }
    } else {
      if (loginUrl.protocol === "https:") {
        window.location.href = loginUrl.toString();
      }
    }
  };

  return (
    <div className={`user-icon ${className}`} onClick={redirectUser}>
      <p
        className={`user-icon-image ${loggedIn && "user-icon-image--loggedin"}`}
      />
    </div>
  );
};

export default UserAvatar;
